if (typeof(Storage) !== "undefined" && localStorage.getItem("fontsLoaded") == true) {
    var htmlEl = document.documentElement;
    if (!htmlEl.classList.contains('fonts-loaded')) {
        htmlEl.classList.add('fonts-loaded');
    }
}
else {

    var Harmattan = new FontFaceObserver('Harmattan');
    var OpenSans = new FontFaceObserver('Open Sans');

    Promise.all([
    	Harmattan.load("لوحة المفاتيح العربية"),
        OpenSans.load()
    ])
    .then(function() {
        document.documentElement.classList.add('fonts-loaded');
        if (typeof(Storage) !== "undefined") {
        	sessionStorage.setItem("fontsLoaded", true);
        }
    })
    .catch(function (err) {
        document.documentElement.classList.remove('fonts-loaded');
        if (typeof(Storage) !== "undefined") {
        	sessionStorage.setItem("fontsLoaded", false);
        }
        console.warn('Some fonts did not load:', err);
    });
}
